// 20250618-xt update StateTabs.js to remove react-bootstrap for Bootstrap 5.3.3 only
import React, { useState } from "react"; // added useState now
import PropTypes from "prop-types";
// import { Tabs, Tab } from "react-bootstrap";  // removed for B5 update
import "./StateTabs.css";

const StateTabs = ({
  toggleStateVisibility,
  agency,
  languageCode,
  tabStatusDetails,
}) => {
  if (!agency.details.display_pages.display_statuses) return <div />;
  if (agency.details.display_pages.display_statuses.length === 0)
    return <div />;

  const statuses = agency.details.display_pages.display_statuses;
  console.log("in stateTabs at statuses: ", statuses[2]);
  var statusesTab = statuses.slice(1);
  console.log("statusesTab is: ", statusesTab);

// 2025018 xt added by grok for B5 update
const defaultActiveKey = tabStatusDetails ? tabStatusDetails : "SHOW_New & Open";
      const [activeTab, setActiveTab] = useState(defaultActiveKey);

      const handleTabClick = (eventKey) => {
        console.log("Tab clicked:", eventKey);
        setActiveTab(eventKey);
        toggleStateVisibility(eventKey);
        
      };
// end of update

  return (
    <div>
          <ul className="nav nav-tabs" id="state_visibility_tabs" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${activeTab === "SHOW_New & Open" ? "active" : ""}`}
                id="new-open-tab"
                data-bs-toggle="tab"
                href="#new-open"
                role="tab"
                aria-controls="new-open"
                aria-selected={activeTab === "SHOW_New & Open"}
                onClick={() => handleTabClick("SHOW_New & Open")}
              >
                New and Open
              </a>
            </li>
            {statusesTab.map((status, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <a
                  className={`nav-link ${activeTab === `SHOW_${status.title[languageCode]}` ? "active" : ""}`}
                  id={`${status.title[languageCode]}-tab`}
                  data-bs-toggle="tab"
                  href={`#${status.title[languageCode]}`}
                  role="tab"
                  aria-controls={status.title[languageCode]}
                  aria-selected={activeTab === `SHOW_${status.title[languageCode]}`}
                  onClick={() => handleTabClick(`SHOW_${status.title[languageCode]}`)}
                >
                  {status.title[languageCode]}
                </a>
              </li>
            ))}
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${activeTab === "SHOW_CHATTING" ? "active" : ""}`}
                id="chatting-tab"
                data-bs-toggle="tab"
                href="#chatting"
                role="tab"
                aria-controls="chatting"
                aria-selected={activeTab === "SHOW_CHATTING"}
                onClick={() => handleTabClick("SHOW_CHATTING")}
              >
                Chatting
              </a>
            </li>
          </ul>
        </div>
      );
    };

StateTabs.propTypes = {
  toggleStateVisibility: PropTypes.func.isRequired,
};

export default StateTabs;
